import React, { createContext, useContext, ReactNode } from 'react'
import { STLLoadResult } from '../utils/stlLoader'
import type { MarketplaceLaunchContext, Tab } from '../types/windows'

export interface TabContextType {
  addGirasolesView: (stlData?: STLLoadResult, projectId?: string) => void
  addSTLInView: (projectName: string, customerName: string, projectId: string) => void
  addSTLOutView: (projectName: string, customerName: string, projectId: string, refreshKey?: string) => void
  addMarketplace: (launchContext?: MarketplaceLaunchContext) => void
  addProfileView: () => void
  addAIAssistant: () => void
  /** List all currently open tabs */
  listTabs: () => Tab[]
  /** Switch to a specific tab by ID */
  switchTab: (tabId: string) => void
}

const TabContext = createContext<TabContextType | null>(null)

export interface TabProviderProps {
  children: ReactNode
  tabActions: TabContextType
}

export const TabProvider: React.FC<TabProviderProps> = ({ children, tabActions }) => {
  return (
    <TabContext.Provider value={tabActions}>
      {children}
    </TabContext.Provider>
  )
}

export const useTabContext = (): TabContextType => {
  const context = useContext(TabContext)
  if (!context) {
    throw new Error('useTabContext must be used within a TabProvider')
  }
  return context
}

/** Returns null when called outside a TabProvider instead of throwing. */
export const useOptionalTabContext = (): TabContextType | null => {
  return useContext(TabContext)
}
